export const SIGN_UP = 'SIGN_UP';
export const LOG_IN = 'LOG_IN';
